import AddEditRightScreen from "../../screens/AddEditRightScreen";
import { connect } from "react-redux";
import {
  editRightCategory,
  addRightCategory,
  deleteRightCategory,
} from "../actions/rightsActions";

const mapDispatchToProps = (dispatch) => ({
  editRightCategory: (newRightCategory, oldRightCategory, navigateFunction) => {
    dispatch(
      editRightCategory(newRightCategory, oldRightCategory, navigateFunction)
    );
  },
  addRightCategory: (newRightCategory, navigateFunction) => {
    dispatch(addRightCategory(newRightCategory, navigateFunction));
  },
  deleteRightCategory: (rightCategory, navigateFunction) => {
    dispatch(deleteRightCategory(rightCategory, navigateFunction));
  },
});

export default connect(null, mapDispatchToProps)(AddEditRightScreen);
